import React, { useEffect, useState } from 'react';

/**
 * One-shot cookie consent banner. Once the shopper hits Accept (or
 * dismisses), we set a per-brand localStorage flag and never bother
 * them again. Storage is namespaced so multiple brands on the same
 * device don't share state.
 */
export default function CookieConsent({ brand }) {
  const [show, setShow] = useState(false);
  const accent = brand?.brand_color || '#422AFB';

  useEffect(() => {
    if (typeof window === 'undefined' || !brand?._id) return undefined;
    try {
      const key = `tpo_cookies_${brand._id}`;
      if (!window.localStorage.getItem(key)) {
        // Tiny delay so the banner doesn't flash before the page paints.
        const t = setTimeout(() => setShow(true), 250);
        return () => clearTimeout(t);
      }
    } catch (_) { /* private mode, etc. — fail open */ }
    return undefined;
  }, [brand?._id]);

  const dismiss = (verdict) => {
    try {
      window.localStorage.setItem(`tpo_cookies_${brand._id}`, verdict);
    } catch (_) { /* private mode */ }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      role='region'
      aria-label='Cookie notice'
      style={{
        position: 'fixed',
        left: 12, right: 12, bottom: 12,
        background: '#0f172a',
        color: '#fff',
        borderRadius: 14,
        padding: '14px 16px',
        zIndex: 50,
        boxShadow: '0 12px 32px rgba(15, 23, 42, 0.25)',
        display: 'flex', alignItems: 'center', gap: 14,
        flexWrap: 'wrap',
      }}
    >
      <div style={{ flex: '1 1 240px', fontSize: 13, lineHeight: 1.4 }}>
        We use a small amount of local storage to remember your cart,
        wishlist, and sign-in. No third-party tracking.
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          type='button'
          onClick={() => dismiss('dismissed')}
          style={{
            background: 'transparent', color: '#cbd5e1',
            border: '1px solid #334155', padding: '8px 14px',
            borderRadius: 10, fontSize: 13, cursor: 'pointer',
          }}
        >
          Dismiss
        </button>
        <button
          type='button'
          onClick={() => dismiss('accepted')}
          style={{
            background: accent, color: '#fff', border: 'none',
            padding: '8px 16px', borderRadius: 10,
            fontSize: 13, fontWeight: 700, cursor: 'pointer',
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
}
